var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { RacingStore } from "../../../data/store";
export class RacingFutureEventsData {
    constructor(provider, openRace) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingGameNavigation = openRace;
    }
    // TODO: Remove when new event view is available
    /* istanbul ignore next */
    openRacingGame(racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId, event) {
        this.racingGameNavigation(event, racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId);
    }
    getFutureEventHandler(event) {
        return this.openRacingGame.bind(this, Number(event.id), this.racingStore.regionId, 2, Number(this.racingStore.branch.id), 0, 0, 0, 0, 0, 0, 0, 0);
    }
    getFutureEventUrl(racingEventUrl, leagueId) {
        return this.racingStore.getRacingEventUrl(racingEventUrl, leagueId);
    }
    get getAntepostEvents() {
        return this.racingStore.sortedAntepostEvents;
    }
    setParams(regionId, branchId) {
        this.racingStore.setParams(regionId, branchId);
    }
}
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], RacingFutureEventsData.prototype, "getAntepostEvents", null);
//# sourceMappingURL=RacingFutureEventsData.js.map